export default "__VITE_ASSET__ClW3XPUt__"